import type { ReactNode, CSSProperties } from 'react';

export function Container({
  children,
  className = '',
  style,
}: {
  children: ReactNode;
  className?: string;
  style?: CSSProperties;
}) {
  return <div className={`mx-auto w-full max-w-[1400px] px-6 md:px-10 ${className}`} style={style}>{children}</div>;
}
